import type { ButtonProps } from '@launchpad-ui/components';
import { Button } from '@launchpad-ui/components';

import { useFormContext } from '../../contexts';

interface SubmitButtonProps extends ButtonProps {
  /** Permit submitting an untouched form, for forms whose default values are already submittable. */
  allowPristine?: boolean;
}

export function SubmitButton({ variant = 'primary', isDisabled, allowPristine = false, ...props }: SubmitButtonProps) {
  const form = useFormContext();

  return (
    <form.Subscribe
      selector={(state) => ({
        isSubmitting: state.isSubmitting,
        isValid: state.isValid,
        isDirty: state.isDirty,
        canSubmit: state.canSubmit,
      })}
    >
      {({ isSubmitting, isValid, isDirty, canSubmit }) => (
        <Button
          isDisabled={isSubmitting || !isValid || (!isDirty && !allowPristine) || !canSubmit || isDisabled}
          isPending={isSubmitting}
          onPress={() => form.handleSubmit()}
          variant={variant}
          {...props}
          data-test-id="submit-button"
        >
          {props.children}
        </Button>
      )}
    </form.Subscribe>
  );
}
